//natives
import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Helmet } from "react-helmet";
// import TagManager from 'react-gtm-module';

//components
import CondicoesPagamentoLista from "../childrens/condicoesPagamentoLista/.mixins";
import Alerta from "../../../../../util/snackbars/.mixins/";

//controllers
import Config from "../../../../../../controllers/config";
import CondicoesPagamento from "../../../../../../controllers/condicoesPagamento";
import Log from "../../../../../../controllers/log";

//childrens
import Columns from "../childrens/columns/.mixins";
import CustomToolbar from "../childrens/customToolbar/.mixins";

export default class ManutencaoCondicoesPagamento extends Component {
    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            title: "Condições Pagamento",
            itens: [],
            itensTable: [],
            columns: [],
            isLoading: true,
            isError: false,
            error: null,
            customToolbar: null,
            setRowProps: row => {
                if (row[5] === "Sim") {
                    return {
                        style: {  borderLeft: '7px solid' }
                    };
                }
            }
        };

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);
        this.handleAdicionar = this.handleAdicionar.bind(this);
    }

    handleAdicionar() {
        this.props.router.push("manutencaoCondicoesPagamento-ae/");
    }

    UNSAFE_componentWillMount() {
        this.setState({
            customToolbar: () => <CustomToolbar {...this} />,
        }),
        this.loadData(null);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-manutencao-condicoes-pagamento',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        Log.info(token, "Efetuado carregamento da tela Condições Pagamento!");
    }

    async loadData(filters) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        try {
            this.setState({ isLoading: true });
            const o_condicoesPagamento = await CondicoesPagamento.getCondicoesPagamento(token);
            const j_condicoesPagamento = JSON.parse(o_condicoesPagamento.body);

            if (o_condicoesPagamento.res.statusCode == 200) {

                const arrayItens = j_condicoesPagamento.map((e) => {
                    return {
                        NR_DIAS_PRAZO: e.deadlineDays ? `${e.deadlineDays} dias` : e.deadlineDays,
                        VP_DESCONTO: e.discountPercent+'%',
                        IN_COND_PADRAO: e.standardCondition === 'S' ? "Sim" : "Não",
                        NM_COND_PAGTO: e.nameConditionPayment,
                        CD_PAGTO: e.paymentId,
                        NM_COND_PAGTO_PADRAO: e?.standardPaymentCondition
                    };
                });

                this.setState({
                    columns: Columns,
                    itensTable: arrayItens,
                    isLoading: false,
                    itens: arrayItens,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-codicoes-pagamento`,
                //     }
                // });
            } else {
                if (
                    j_condicoesPagamento.status == false &&
                    j_condicoesPagamento.message &&
                    j_condicoesPagamento.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno("Autentificação inválida!", "error");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            this.child.current.retorno("Erro ao carregar dados!", "error");
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:manutencao-condicoes-pagamento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Condições Pagamento`}</title>
                </Helmet>
                <CondicoesPagamentoLista {...this} />
                <Alerta ref={this.child} />
            </div>
        );
    }
}
